import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { IAssessmentQuestion } from 'interfaces/assessments';
import { useMemo, useState } from 'react';

const { Text } = Typography;

interface AttemptQuestionProps {
  index: number;
  question: IAssessmentQuestion;
}

export const AttemptObjectiveQuestion = ({
  index,
  question
}: AttemptQuestionProps) => {
  const [showGabarito, setShowGabarito] = useState(false);

  const chosenAlternative = useMemo(() => {
    return question.alternatives?.find(
      alternative => alternative.id === question.alternative_id
    );
  }, [question.alternatives, question.alternative_id]);

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Text strong style={{ fontSize: 12 }}>
        Questão {index + 1} (Objetiva)
      </Text>

      <div
        style={{
          display: 'block',
          fontWeight: 600,
          marginBottom: 8
        }}
        dangerouslySetInnerHTML={{
          __html: question.statement
        }}
      />

      <Space direction="vertical" style={{ width: '100%', marginBottom: 8 }}>
        <Text style={{ fontSize: 12 }}>Alternativa escolhida pelo aluno</Text>
        <Card size="small">
          <div
            style={{
              whiteSpace: 'break-spaces',
              color: 'rgba(0, 0, 0, 0.45)'
            }}
            dangerouslySetInnerHTML={{
              __html: chosenAlternative?.statement || 'Sem resposta'
            }}
          />
        </Card>
      </Space>

      {showGabarito && (
        <Space
          direction="vertical"
          style={{
            marginBottom: 8
          }}
        >
          <Text style={{ fontSize: 12 }}>Gabarito</Text>
          <Card size="small">
            <Text type="secondary">{question.feedback}</Text>
          </Card>
        </Space>
      )}

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={24} md={4}>
          <Text style={{ fontSize: 14, fontWeight: 'bold' }}>Nota (0-100)</Text>
          <Card size="small">
            <Text type="secondary" style={{ whiteSpace: 'break-spaces' }}>
              {question.status === 'correct' || question.status === 'nullified'
                ? '100'
                : '0'}
            </Text>
          </Card>
        </Col>
      </Row>

      <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
        <Button
          type="text"
          htmlType="button"
          onClick={() => setShowGabarito(!showGabarito)}
        >
          {showGabarito ? 'Esconder gabarito' : 'Visualizar gabarito'}
        </Button>
      </Space>
    </Space>
  );
};
